'use client';

import Link from "next/link";
import Image from "next/image";
import { authClient } from "@/lib/auth-client";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useLanguage } from "@/lib/LanguageContext";
import { useBrandName } from "@/lib/BrandContext";

export function LandingNav() {
    const { data: session } = authClient.useSession();
    const { t } = useLanguage();
    const brand = useBrandName();

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <Image
                        src="/assets/images/logo-1p.svg"
                        alt={brand}
                        width={36}
                        height={36}
                        className="drop-shadow-md"
                    />
                    <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-emerald-600 via-cyan-600 to-blue-600">{brand}</span>
                </div>
                <div className="flex items-center gap-3">
                    <LanguageSwitcher />
                    <Link
                        href="/agent"
                        className="px-6 py-2 rounded-full bg-blue-600 text-white font-medium hover:bg-blue-700 transition-all hover:scale-105 shadow-md"
                    >
                        {session ? t('common.dashboard') : t('common.getStarted')}
                    </Link>
                </div>
            </div>
        </nav>
    );
}

